import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PackagesSectionComponent } from './packages-section/packages-section.component';
import { FeaturedCoinSectionComponent } from './featured-coin-section/featured-coin-section.component';
import { WelcomeBannerSectionComponent } from './welcome-banner-section/welcome-banner-section.component';
import { FooterSectionComponent } from './footer-section/footer-section.component';
import { RouterModule } from '@angular/router';

import { CarouselModule } from 'ngx-owl-carousel-o';
const SharedSections = [
  PackagesSectionComponent,
  FeaturedCoinSectionComponent,
  WelcomeBannerSectionComponent,
  FooterSectionComponent
]

@NgModule({
  declarations: [SharedSections],
  imports: [
    CarouselModule,
    CommonModule,
    RouterModule
  ],
  exports:[SharedSections]
})
export class SectionsModule { }
